var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6276 8.00965V14.9999H2.82764V8.00965",
    stroke: "#069C54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2275 4.51476H1.22754V8.00988H17.2275V4.51476Z",
    stroke: "#069C54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22754 15.0001V4.51476",
    stroke: "#069C54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22744 4.51465H5.62744C5.09701 4.51465 4.5883 4.33053 4.21323 4.0028C3.83816 3.67507 3.62744 3.23057 3.62744 2.76709C3.62744 2.30361 3.83816 1.85911 4.21323 1.53138C4.5883 1.20365 5.09701 1.01953 5.62744 1.01953C8.42744 1.01953 9.22744 4.51465 9.22744 4.51465Z",
    stroke: "#069C54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22754 4.51465H12.8275C13.358 4.51465 13.8667 4.33053 14.2418 4.0028C14.6168 3.67507 14.8275 3.23057 14.8275 2.76709C14.8275 2.30361 14.6168 1.85911 14.2418 1.53138C13.8667 1.20365 13.358 1.01953 12.8275 1.01953C10.0275 1.01953 9.22754 4.51465 9.22754 4.51465Z",
    stroke: "#069C54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGift);
export default __webpack_public_path__ + "static/media/green-gift.4d92924dca452d1f0f09dd5f5293e99f.svg";
export { ForwardRef as ReactComponent };